const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeslash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    style: {
      color: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.73698,0,0,0.73698,-10.6157,90.2311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.783,23.926C155.029,26.221 158.691,26.27 160.889,23.926C163.135,21.631 163.135,18.066 160.889,15.82L49.805,-95.166C47.559,-97.412 43.848,-97.412 41.602,-95.166C39.453,-93.018 39.453,-89.209 41.602,-87.061L152.783,23.926ZM159.424,1.465C177.539,-11.426 188.086,-27.93 188.086,-35.107C188.086,-47.9 154.639,-90.527 101.221,-90.527C90.674,-90.527 80.859,-88.818 71.924,-85.986L91.894,-66.016C94.922,-66.894 98.047,-67.383 101.318,-67.383C119.238,-67.383 133.838,-53.027 133.838,-35.059C133.838,-31.787 133.35,-28.613 132.373,-25.586L159.424,1.465ZM101.221,20.313C112.207,20.313 122.363,18.506 131.543,15.527L111.475,-4.541C108.301,-3.418 104.834,-2.783 101.318,-2.783C83.35,-2.783 68.701,-17.627 68.701,-35.059C68.701,-38.721 69.336,-42.236 70.508,-45.508L43.994,-71.973C25.293,-58.984 14.404,-42.334 14.404,-35.107C14.404,-22.315 48.682,20.313 101.221,20.313ZM122.314,-36.475C122.314,-47.656 113.232,-56.738 102.002,-56.738L101.221,-56.738L122.266,-35.645C122.314,-35.938 122.314,-36.182 122.314,-36.475ZM79.883,-35.059C79.883,-23.877 89.063,-14.746 100.244,-14.746C100.537,-14.746 100.781,-14.795 101.123,-14.795L79.932,-35.986C79.932,-35.645 79.883,-35.352 79.883,-35.059Z",
    style: {
      color: "currentColor",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeslash);
export default __webpack_public_path__ + "static/media/eye.slash.9b5e0dbd.svg";
export { ForwardRef as ReactComponent };